import { render, staticRenderFns } from "./theme-class.vue?vue&type=template&id=40ff2018&scoped=true"
import script from "./theme-class.vue?vue&type=script&setup=true&lang=ts"
export * from "./theme-class.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./theme-class.vue?vue&type=style&index=0&id=40ff2018&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ff2018",
  null
  
)

export default component.exports